<div class="flex flex-column gap-4 w-full text-left">
	<!-- Contexto: Acceso a la cuenta -->
	<label class="context-label text-center w-full">
		{{ translations['accessyourAccounttoContinue'] || 'Accede a tu cuenta para continuar' }}
	</label>
		<!-- Formulario Reactivo -->
	<form [formGroup]="formGroup" class="flex flex-column gap-3 w-full">
		<!-- Contenedor del formulario -->
		<div class="flex flex-column align-items-stretch align-self-stretch gap-4">
			<!-- Input: Email -->
			<div class="w-full flex flex-column gap-2">
				<label [for]="'email'" class="field-label font-semibold text-black">
					{{ translations['email'] || 'Email*' }}*
				</label>
				<app-input
					type="email"
					id="email"
					formControlName="email"
					[control]="formGroup.get('email')"
					[placeholder]="translations['email'] || 'Email'"
				></app-input>
				<span class="error-message block mt-1" *ngIf="isFieldInvalid('email')">
					{{ getFieldErrorMessage('email') }}
				</span>
			</div>

			<!-- Input: Password -->
			<div class="w-full flex flex-column gap-2">
				<label [for]="'password'" class="field-label font-semibold text-black">
					{{ translations['password'] || 'Password*' }}*
				</label>
				<app-input
					type="password"
					id="password"
					formControlName="password"
					[control]="formGroup.get('password')"
					[placeholder]="translations['password'] || 'Password'"
				></app-input>
				<span class="error-message block mt-1" *ngIf="isFieldInvalid('password')">
					{{ getFieldErrorMessage('password') }}
				</span>
				<div class="w-full flex justify-content-end mt-2">
					<a class="text-black cursor-pointer font-bold" (click)="navigateTo(AuthModalComponentEnum.RESET_PASSWORD)">
						{{ translations['forgotPassword'] || '¿Olvidaste tu contraseña?' }}
					</a>
				</div>
			</div>
		</div>

		<!-- Botón de Inicio de Sesión -->
		<div class="flex flex-column align-items-center pt-4 w-full align-self-stretch">
			<app-button
				class="w-full block"
				[text]="translations['logIn'] || 'Iniciar sesión'"
				[type]="getButtonType(formGroup.invalid || (loading$ | async) || !!(loadingStore$ | async))"
				[disabled]="formGroup.invalid || (loading$ | async) || !!(loadingStore$ | async)"
				(buttonClicked)="onLogIn()"
			></app-button>
		</div>
	</form>

	<div class="w-full">
		<p class="register-text text-center font-normal line-height-2">
			{{ translations['dontHaveAccount'] || '¿No tienes una cuenta?' }}
			<a class="text-black cursor-pointer font-bold" (click)="navigateTo(AuthModalComponentEnum.SIGNUP)">
				{{ translations['signUp'] || 'Registrarse' }}
			</a>
		</p>

		<!-- Sección de Invitado (Solo se muestra si visitingCheckout es true) -->
		<div class="flex flex-column gap-3 text-center mt-3" *ngIf="visitingCheckout">
			<div class="flex justify-content-center align-items-center gap-2 align-self-stretch text-sm text-black">
				<hr class="flex-1 border-none border-top-1 border-400 m-0" />
				or
				<hr class="flex-1 border-none border-top-1 border-400 m-0" />
			</div>
			<app-button
				class="w-full block"
				[text]="translations['continueAsGuest'] || 'Continuar como invitado'"
				type="button-outline"
				(buttonClicked)="navigateGuest()"
			></app-button>
		</div>
	</div>
</div>
